import { useMemo } from 'react'

// For class components
export const extractUrlSearchParams = (
    searchString: string,
    params: string[],
) => {
    const urlParams = new URLSearchParams(searchString)
    const paramsObj: { [key: string]: string | null } = {}

    params.forEach(param => (paramsObj[param] = urlParams.get(param)))

    return paramsObj
}

// For functional components (ideal)
export const useExtractUrlSearchParams = (
    searchString: string,
    params: string[],
) =>
    useMemo(
        () => extractUrlSearchParams(searchString, params),
        [searchString, params],
    )
